import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function SignoutIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "15"}
      height={height || "15"}
      viewBox="0 0 15 15"
    >
      <g
        id="Signout_Icon"
        data-name="Signout Icon"
        transform="translate(-3 -3)"
      >
        <path
          id="Path_10078"
          data-name="Path 10078"
          d="M9.492,14.075a.83.83,0,0,0,1.175,0l2.992-2.992a.83.83,0,0,0,0-1.175L10.667,6.917A.831.831,0,1,0,9.492,8.092l1.567,1.575H3.833a.833.833,0,0,0,0,1.667h7.225L9.492,12.9A.838.838,0,0,0,9.492,14.075ZM16.333,3H4.667A1.666,1.666,0,0,0,3,4.667v2.5a.833.833,0,1,0,1.667,0V5.5A.836.836,0,0,1,5.5,4.667h10a.836.836,0,0,1,.833.833v10a.836.836,0,0,1-.833.833H5.5a.836.836,0,0,1-.833-.833V13.833a.833.833,0,0,0-1.667,0v2.5A1.672,1.672,0,0,0,4.667,18H16.333A1.672,1.672,0,0,0,18,16.333V4.667A1.672,1.672,0,0,0,16.333,3Z"
          fill={color || "#2f2f2f"}
        />
      </g>
    </svg>
  );
}
